import { useCallback } from 'react';

interface ColHandleProps {
    colIndex: number;
    colWidths: number[];
    onResize: (updated: number[]) => void;
}

export function ColHandle({ colIndex, colWidths, onResize }: ColHandleProps) {
    const onMouseDown = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const startX = e.clientX;
            const leftPct = colWidths[colIndex];
            const rightPct = colWidths[colIndex + 1];
            const totalPct = leftPct + rightPct;
            const container = (e.currentTarget as HTMLElement).closest(
                '[data-image-grid-container]'
            );
            const containerWidth = container?.getBoundingClientRect().width ?? 600;

            const onMove = (ev: MouseEvent) => {
                const pctDx = ((ev.clientX - startX) / containerWidth) * 100;
                const newLeft = Math.max(5, Math.min(totalPct - 5, leftPct + pctDx));
                const updated = [...colWidths];
                updated[colIndex] = Math.round(newLeft * 10) / 10;
                updated[colIndex + 1] = Math.round((totalPct - newLeft) * 10) / 10;
                onResize(updated);
            };

            const onUp = () => {
                window.removeEventListener('mousemove', onMove);
                window.removeEventListener('mouseup', onUp);
            };

            window.addEventListener('mousemove', onMove);
            window.addEventListener('mouseup', onUp);
        },
        [colIndex, colWidths, onResize]
    );

    return (
        <div
            className="image-grid-col-handle"
            style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: -2,
                width: 4,
                cursor: 'ew-resize',
                zIndex: 10
            }}
            onMouseDown={onMouseDown}
        />
    );
}
